import { idSchema } from '@/lib/utils'
import { z } from 'zod/v4'

export const notificationRecipientSchema = z.object({
  recipientId: idSchema('notification-recipient'),
})
